
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Icon,Select, Button,Modal, message,Form,Input,Upload,Spin} from 'antd'
import { signGet, signSet, discountList } from '_src/api/api'
import './style/signBoard.less'

const { Option } = Select
@Form.create({ name: '' })
class SignBoard extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            signCouponDays: 0,
            signCouponReward: null,
            signExtraDays: 0,
            signExtraReward: 0,
            isLoading: true,
            createModelVisible:false,
            modalIndex: 1,
            discountList:[],
        }
    }

    componentDidMount() {
        this.getSetInfo()
        this.getDiscount()
    }

    getSetInfo() {
        this.setState({ isLoading: true })
        signGet().then(res =>{
            if(res.data){
                const data = res.data
                this.setState({
                    isLoading:false,
                    signCouponDays: data.signCouponDays,
                    signCouponReward: data.signCouponReward,
                    signExtraDays: data.signExtraDays,
                    signExtraReward: data.signExtraReward
                })
            }
		}).catch(e => {
			this.setState({
				isLoading:false
			})
		})
    }

    getDiscount(){
		discountList({pageSize:-1}).then(res => {
			if(res){
				this.setState({
					discountList:res.data
				})
			}
		})
	}

    settingPanel(key) {
        this.setState({
            modalIndex: key,
            createModelVisible: true
        })
    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields((err, values) =>{
            if(!err){
                const hide = message.loading('提交中')
                signSet(values).then(res => {
                    hide()
                    if(res.data === 'success'){
                        message.success('设置成功')
                        this.getSetInfo()
                        this.setState({
                            createModelVisible:false
                        })
                    }
                }).catch( err => {
                    console.log(err)
                })
            }
        })
    }

    render() {
        const { isLoading, createModelVisible, modalIndex, discountList, signExtraDays, signExtraReward, signCouponDays, signCouponReward } = this.state
        const { getFieldDecorator } = this.props.form
        let couponKey = null
        if(discountList && discountList.length>0){
            for(let i in discountList) {
                if(discountList[i].name == signCouponReward) {
                    couponKey = discountList[i].id
                }
            }
        }
        return (
            <div className="signSetting">
                {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
                <div className="tableContain">
                    <div className="tableTitle"> <Icon type="unordered-list" /> 签到额外积分奖励</div>
                    <div className="tableContent">
                        <div className="tableTop">
                            <div className="item">每连续签到天数</div>
                            <div className="item">额外奖励积分数</div>
							<div className="item">操作</div>
                        </div>
                        <div className="tableBottom">
                            <div className="item">{signExtraDays}</div>
                            <div className="item">{signExtraReward}</div>
							<div className="item"><span className='setting' onClick={()=>this.settingPanel(1)}>设置</span></div>
                        </div>
                    </div>
                </div>
                <div className="tableContain">
                    <div className="tableTitle"> <Icon type="unordered-list" /> 签到优惠券奖励</div>
                    <div className="tableContent">
                        <div className="tableTop">
                            <div className="item">每连续签到天数</div>
                            <div className="item">优惠券奖励</div>
							<div className="item">操作</div>
                        </div>
                        <div className="tableBottom">
                            <div className="item">{signCouponDays}</div>
                            <div className="item">{signCouponReward}</div>
							<div className="item"><span className='setting' onClick={()=>this.settingPanel(2)}>设置</span></div>
                        </div>
                    </div>
                </div>
                <Modal
					title={modalIndex === 1 ?'积分奖励设置':'优惠券奖励设置'}
					visible={createModelVisible}
					onCancel={() => {
						this.setState({
						    createModelVisible: false,
						})
					}}
					width={500}
					footer={false}
					destroyOnClose
					>
                        {modalIndex === 1
                        ?<Form className='push-modal-inner' onSubmit={this.handleSubmit} style={{ paddingLeft: 10 }}>
                            <Form.Item label="每连续签到天数:" className='flex'>
                                {getFieldDecorator('signExtraDays',{
                                    rules: [{
                                        required: true,
                                        message: '请输入连续签到天数',
                                    }],
                                    initialValue: signExtraDays,
                                })(
                                    <Input placeholder="请输入连续签到天数" style={{ width: 300 }} />
                                )}
                            </Form.Item>
                            <Form.Item label="额外奖励积分数:" className='flex'>
                                {getFieldDecorator('signExtraReward',{
                                    rules: [{
                                        required: true,
                                        message: '请输入奖励积分数',
                                    }],
                                    initialValue: signExtraReward,
                                })(
                                    <Input placeholder="请输入奖励积分数" style={{ width: 300 }} />
                                )}
                            </Form.Item>
                            <Form.Item>
					            <Button type="primary" htmlType="submit" size='large' style={{ width: 400, marginLeft: 15, marginTop: 0 }}>保存</Button>
					        </Form.Item>
                        </Form>
                        :<Form className='push-modal-inner' onSubmit={this.handleSubmit} style={{ paddingLeft: 10 }}>
                            <Form.Item label="每连续签到天数:" className='flex'>
                                {getFieldDecorator('signCouponDays',{
                                    rules: [{
                                        required: true,
                                        message: '请输入连续签到天数',
                                    }],
                                    initialValue: signCouponDays,
                                })(
                                    <Input placeholder="请输入连续签到天数" style={{ width: 300 }} />
                                )}
                            </Form.Item>
                            <Form.Item label="优惠券奖励" className='flex'>
                                {getFieldDecorator('signCouponReward', {
                                    rules: [{ 
                                        required: true, 
                                        message: '请选择优惠券奖励'
                                    }],
                                    initialValue: couponKey,
                                })(
                                    <Select placeholder="请选择优惠券奖励" style={{ width: 300, height: 32 }}>
                                        {
                                            discountList && discountList.length>0 ? discountList.map(item => {
                                                return <Option value={item.id} key={item.id}>{item.name}</Option>
                                            })
                                            :null
                                        }
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item>
					            <Button type="primary" htmlType="submit" size='large' style={{ width: 400, marginLeft: 20, marginTop: 0 }}>保存</Button>
					        </Form.Item>
                        </Form>}
				</Modal>
            </div>
        )
    }
}
export default connect()(SignBoard)